import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * A function with a stable identity that always runs the LATEST `fn` given on
 * the last render (the shape of React's useEffectEvent).
 *
 * For an effect whose dependency list names WHEN it runs (a page's filter, an
 * id) while the work it starts reads other values at call time (headers, a
 * token, the branch): listing the returned function as a dependency never
 * re-runs the effect, so the effect still fires only on its own triggers and
 * never on a stale closure.
 */
export default function useLatestCallback(fn) {
  const ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useCallback((...args) => ref.current(...args), []);
}
